import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

const candidateCategories = [
  { value: "all", labelId: "blog.categories.all" },
  { value: "career_advise", labelId: "blog.categories.advices" },
  { value: "interviews_and_cv", labelId: "blog.categories.interviews_and_cv" },
  { value: "candidate_actuality", labelId: "blog.categories.actualities" },
];

const recruiterCategories = [
  { value: "all", labelId: "blog.categories.all" },
  { value: "how_to_recruit", labelId: "blog.categories.how_to_recruit" },
  { value: "human_resources", labelId: "blog.categories.human_resources" },
  { value: "recruiter_actuality", labelId: "blog.categories.actualities" },
];

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "hsl(153 68% 25%)",
  },
  container: {
    maxWidth: 1350,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    gap: 4,
    overflowX: "auto",
    padding: "0.5rem",
    minHeight: "52px",
  },
  tab: {
    "&&&": {
      whiteSpace: "nowrap",
      borderRadius: "4px",
      padding: "8px 16px",
      fontSize: 14,
      textTransform: "none",
      minWidth: "auto",
      minHeight: 0,
      height: "auto",
      lineHeight: 1.25,
      fontFamily: "Segoe UI Semibold, system-ui, sans-serif !important",
    },
  },
  activeTab: {
    "&&&": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      color: "#fff",
    },
  },
  inactiveTab: {
    "&&&": {
      backgroundColor: "transparent",
      color: "rgba(255, 255, 255, 0.7)",
    },
    "&&&:hover": {
      backgroundColor: "transparent",
      color: "#fff",
    },
  },
  segmentedControl: {
    display: "flex",
    position: "relative",
    borderRadius: 8,
    border: "1px solid rgba(255, 255, 255, 0.15)",
    flexShrink: 0,
    overflow: "hidden",
  },
  segment: {
    padding: "6px 16px",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    cursor: "pointer",
    userSelect: "none",
    transition: "color 0.2s ease, background-color 0.2s ease",
    lineHeight: 1.25,
    textAlign: "center",
  },
  segmentActive: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    color: "#fff",
  },
  segmentInactive: {
    backgroundColor: "transparent",
    color: "rgba(255, 255, 255, 0.5)",
    "&:hover": {
      color: "rgba(255, 255, 255, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 0.05)",
    },
  },
  segmentDivider: {
    width: 1,
    alignSelf: "stretch",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
  },
}));

const CategoryTabs = ({ active, onChange, activeType }) => {
  const classes = useStyles();
  const categories =
    activeType === "recruiter" ? recruiterCategories : candidateCategories;

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        {categories.map((cat) => (
          <Button
            key={cat.value}
            onClick={() => onChange(cat.value)}
            className={`${classes.tab} ${
              active === cat.value ? classes.activeTab : classes.inactiveTab
            }`}
            disableRipple
          >
            <FormattedMessage id={cat.labelId} />
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default CategoryTabs;
